// Auto-generated cornerstone translation for el.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:21:44.013786+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Εφαρμογή διαχείρισης αλόγου: η καλύτερη επιλογή για το 2026 | EquiSight",
      description: "Συγκρίνετε εφαρμογές διαχείρισης αλόγου για ιδιοκτήτες, στάβλους και εκτροφεία. Ανακαλύψτε γιατί το EquiSight είναι η ολοκληρωμένη εφαρμογή για το άλογό σας.",
      keywords: [
        "εφαρμογή διαχείρισης αλόγου",
        "εφαρμογή διαχείρισης στάβλου",
        "εφαρμογή ημερολογίου αλόγου",
        "εφαρμογή διαχείρισης πολλαπλών αλόγων",
        "εφαρμογή εγκυμοσύνης φοράδας",
        "εφαρμογή εκτροφείου αλόγων",
        "καλύτερη εφαρμογή διαχείρισης αλόγου",
      ],
    },
    hero: {
      eyebrow: "Οδηγός επιλογής · λογισμικό διαχείρισης αλόγου",
      breadcrumbLabel: "Εφαρμογή διαχείρισης αλόγου",
      title: "Εφαρμογή διαχείρισης αλόγου: ο πλήρης οδηγός επιλογής για ιδιοκτήτες, στάβλους και εκτροφεία.",
      intro: "Όχι απλώς μια λίστα λειτουργιών — μια ειλικρινής σύγκριση, ένας οδηγός επιλογής και μια ματιά σε αυτό που μια εφαρμογή διαχείρισης αλόγου πρέπει πραγματικά να κάνει το 2026. Για ένα άλογο, για έναν ολόκληρο στάβλο ή για το εκτροφείο σας.",
      pills: [
        {
          icon: "Users",
          label: "Για ιδιοκτήτες",
        },
        {
          icon: "Building2",
          label: "Για στάβλους",
        },
        {
          icon: "Baby",
          label: "Για εκτροφεία",
        },
        {
          icon: "Share2",
          label: "Για ομάδες",
        },
      ],
      ctas: [
        {
          label: "Ξεκινήστε δωρεάν με 1 άλογο",
          href: "#start",
          primary: true,
        },
        {
          label: "Προς τον πίνακα σύγκρισης",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Γιατί μια εφαρμογή διαχείρισης αλόγου γίνεται όλο και πιο σημαντική.",
      lead: "Η διαχείριση αλόγου στην πράξη είναι κατακερματισμένη: WhatsApp, ημερολόγιο, Excel, φωτογραφίες στο τηλέφωνο, χάρτινο διαβατήριο, διάσπαρτα τιμολόγια και προφορικές συμφωνίες. Ενοχλητικό ακόμα και με ένα άλογο. Με περισσότερα άλογα, εκτροφεία ή κοινή φροντίδα δημιουργούνται κενά, χαμένα ραντεβού και παρεξηγήσεις.",
      items: [
        "Πού ήταν εκείνη η ημερομηνία εμβολιασμού;",
        "Ποιος πλήρωσε τον πεταλωτή;",
        "Ποια φοράδα πρέπει να ελεγχθεί σήμερα;",
        "Διάβασε ο εκπαιδευτής τις οδηγίες της περασμένης εβδομάδας;",
        "Έχω αποθηκεύσει πραγματικά αυτό το έγγραφο με τη φωτογραφία;",
        "Είναι ακόμα σωστό το πρόγραμμα σίτισης που κρέμεται στον στάβλο;",
      ],
    },
    what: {
      title: "Τι είναι μια εφαρμογή διαχείρισης αλόγου;",
      lead: "Μια εφαρμογή διαχείρισης αλόγου είναι στην ουσία ένας ψηφιακός φάκελος ανά άλογο. Χωρίς διάσπαρτες σημειώσεις, αλλά ένα μέρος για υγεία, εκπαίδευση, διατροφή, έγγραφα, προγραμματισμό, υπενθυμίσεις, κόστη, φωτογραφίες, βίντεο και κοινόχρηστη πρόσβαση. Όλοι γύρω από το άλογο βλέπουν τις ίδιες, ενημερωμένες πληροφορίες.",
      targetGroupsTitle: "Για ποιον προορίζεται μια εφαρμογή διαχείρισης αλόγου;",
      targetGroups: [
        {
          icon: "Heart",
          title: "Ιδιώτης ιδιοκτήτης",
          body: "Ένα άλογο, ένας φάκελος — υγεία, προγραμματισμός και ιστορικό στην τσέπη σας.",
        },
        {
          icon: "Users",
          title: "Ιδιοκτήτης με πολλαπλά άλογα",
          body: "Ξεχωριστά προφίλ, ξεχωριστός προγραμματισμός, κοινή λίστα εργασιών για ολόκληρη την ομάδα.",
        },
        {
          icon: "Building2",
          title: "Στάβλος φύλαξης & ιππόδρομος",
          body: "Πρόσβαση ιδιοκτήτη, οδηγίες φροντίδας, κοινό ημερολόγιο και εργασίες.",
        },
        {
          icon: "Baby",
          title: "Εκτροφείο",
          body: "Κύκλος φοράδας, κύηση, στοιχεία επιβήτορα, γενεαλογικό δέντρο και ανάπτυξη πουλαριού.",
        },
        {
          icon: "Target",
          title: "Εκπαιδευτές",
          body: "Επισκόπηση ανά άλογο, καταγραφή συνεδριών, ορισμός στόχων, ανάλυση βίντεο.",
        },
        {
          icon: "ClipboardList",
          title: "Επαγγελματίες",
          body: "Πεταλωτής, οδοντίατρος, φυσιοθεραπευτής ή κτηνίατρος — εργάζονται από τον ίδιο φάκελο.",
        },
      ],
    },
    criteria: {
      title: "Τι πρέπει να πληροί μια καλή εφαρμογή διαχείρισης αλόγου;",
      lead: "Μια εφαρμογή δεν είναι μόνο όμορφη — πρέπει να λειτουργεί πρακτικά καθημερινά. Πέντε στοιχεία που δεν πρέπει να λείπουν στην επιλογή του 2026.",
      items: [
        {
          icon: "FileText",
          title: "Φάκελος ανά άλογο",
          body: "Στοιχεία, ηλικία, ράτσα, πληροφορίες διαβατηρίου, ιδιοκτήτης, στάβλος, φωτογραφίες και έγγραφα — όλα συνδεδεμένα σε ένα προφίλ αλόγου.",
        },
        {
          icon: "Heart",
          title: "Υγεία και φροντίδα",
          body: "Εμβολιασμοί, αποπαρασίτωση, πεταλωτής, οδοντίατρος, κτηνίατρος, θεραπείες, φαρμακευτική αγωγή και αυτόματες υπενθυμίσεις πριν από την ημερομηνία λήξης.",
        },
        {
          icon: "Activity",
          title: "Εκπαίδευση και πρόοδος",
          body: "Καταγραφή προπονήσεων, σημειώσεις, βίντεο, αποτελέσματα αγώνων, στόχοι και πρόοδος ανά κλάδο ή ανά άλογο.",
        },
        {
          icon: "Apple",
          title: "Διατροφή και διαχείριση",
          body: "Προγράμματα σίτισης, συμπληρώματα, χονδρή τροφή, βάρος, σωματική κατάσταση και η καθημερινή ρουτίνα που πρέπει να γνωρίζει ο στάβλος.",
        },
        {
          icon: "Share2",
          title: "Κοινή χρήση με άλλους",
          body: "Πρόσβαση για ιδιοκτήτη, φροντιστή, εκπαιδευτή, διαχειριστή στάβλου ή επαγγελματία — με διαχείριση δικαιωμάτων που ταιριάζει στον ρόλο του καθενός.",
        },
        {
          icon: "Calendar",
          title: "Προγραμματισμός και υπενθυμίσεις",
          body: "Ένα κοινό ημερολόγιο με εργασίες, αυτόματες υπενθυμίσεις και επιβεβαίωση ώστε τίποτα να μην ξεφεύγει.",
        },
      ],
    },
    comparison: {
      title: "EquiSight εναντίον άλλων εφαρμογών διαχείρισης αλόγου.",
      lead: "Το ολλανδικό SERP καλύπτεται επί του παρόντος από τα Stalmanager, LogMyHorse, EquineM και Happie Horse. Το καθένα έχει τα δυνατά του σημεία. Παραθέτουμε τις πιο ζητούμενες λειτουργίες δίπλα-δίπλα, ειλικρινά και βάσει δημοσίως διαθέσιμων πληροφοριών.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Δωρεάν έναρξη",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Πολλαπλά άλογα",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Φάκελος υγείας",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Εκπαίδευση & πρόοδος",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Διατροφή & συμπληρώματα",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Προγραμματισμός & υπενθυμίσεις",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Έγγραφα ανά άλογο",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Κοινή χρήση με ομάδα & δικαιώματα",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Μονάδα εκτροφείου (πλήρης)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Κύκλος φοράδας",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Σχεδιασμός κύησης + υπερηχογραφήματα",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ανάπτυξη πουλαριού",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ενσωμάτωση επαγγελματιών",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Πληροφορίες EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Κατάλληλο για ιδιοκτήτες",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Κατάλληλο για εκτροφεία",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Κατάλληλο για στάβλο/ιππόδρομο",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Σύγκριση βάσει δημοσίως διαθέσιμων λειτουργιών τον Ιανουάριο του 2026. Οι ανταγωνιστές είναι επίσης καλά εργαλεία· το EquiSight έχει δημιουργηθεί για να συνδυάζει όλες τις ενότητες σε μία εφαρμογή.",
    },
    why: {
      title: "Γιατί το EquiSight είναι διαφορετικό.",
      lead: "Ένα ημερολόγιο καταγράφει. Το EquiSight συνδυάζει διαχείριση αλόγου, εκπαίδευση, διατροφή, υγεία, αγώνες, επαγγελματίες και εκτροφείο σε μία σύγχρονη εφαρμογή — και πηγαίνει ένα βήμα παραπέρα με πληροφορίες.",
      points: [
        {
          icon: "Heart",
          title: "Μία εφαρμογή για όλη τη ζωή του αλόγου",
          body: "Από πουλάρι έως αθλητικό άλογο, φοράδα εκτροφής ή άλογο σύνταξης. Ο φάκελος μεγαλώνει μαζί με το άλογό σας — τίποτα δεν χάνεται στην πορεία.",
        },
        {
          icon: "Sparkles",
          title: "Όχι μόνο δεδομένα, αλλά και μοτίβα",
          body: "Το EquiCoach συνδυάζει ανάπτυξη, επαναλαμβανόμενα προβλήματα, εκπαίδευση και διατροφή — ώστε να βλέπετε σήματα έγκαιρα, όχι μεμονωμένες ειδοποιήσεις.",
        },
        {
          icon: "Share2",
          title: "Φτιαγμένο για συνεργασία",
          body: "Ιδιοκτήτης, διαχειριστής στάβλου, εκπαιδευτής, πεταλωτής και άλλοι επαγγελματίες εργάζονται από τον ίδιο φάκελο αλόγου — με τα δικαιώματα που αντιστοιχούν στον ρόλο τους.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Εξειδίκευση · εκτροφείο",
      title: "Διαχείριση αλόγου για εκτροφεία.",
      lead: "Πολλοί ανταγωνιστές αναφέρουν το εκτροφείο σε μία γραμμή. Το EquiSight δημιούργησε μια πλήρη ενότητα εκτροφείου — επειδή ο εκτροφέας σπάνια είναι ο τελικός χρήστης μιας γενικής εφαρμογής, ενώ ο προγραμματισμός χρειάζεται περισσότερο από τον οποιονδήποτε άλλο.",
      items: [
        "Καθημερινή παρακολούθηση κύκλου φοράδας",
        "Ημερομηνία σπερματέγχυσης + στοιχεία επιβήτορα",
        "Έλεγχος κύησης με υπερηχογραφήματα",
        "Αναμενόμενη ημερομηνία γέννας + προειδοποιήσεις",
        "Ανάπτυξη πουλαριού ανά μήνα",
        "Γενεαλογικό δέντρο και καταγωγή",
        "Σημειώσεις ανά φοράδα",
        "Επισκόπηση όλων των εγκύων φοράδων",
      ],
      ctaLabel: "Δείτε την ενότητα εκτροφείου",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Εξειδίκευση · στάβλος & ιππόδρομος",
      title: "Διαχείριση αλόγου για πολλαπλά άλογα και στάβλους φύλαξης.",
      lead: "Με πολλαπλά άλογα, το θέμα είναι λιγότερο τα δεδομένα και περισσότερο η επικοινωνία. Κάθε ιδιοκτήτης έχει τις δικές του επιθυμίες, ρουτίνες, συμφωνίες σίτισης και ιατρικά σημεία προσοχής. Κάθε εργαζόμενος πρέπει να έχει πρόσβαση σε αυτά χωρίς αναζήτηση.",
      cards: [
        {
          t: "Άλογα ανά ιδιοκτήτη",
          d: "Κάθε ιδιοκτήτης βλέπει μόνο το/τα δικό/ά του άλογο/α.",
        },
        {
          t: "Οδηγίες φροντίδας",
          d: "Ορατές ανά άλογο για τον στάβλο.",
        },
        {
          t: "Κοινό ημερολόγιο",
          d: "Πεταλωτής, κτηνίατρος και αγώνες σε μία προβολή.",
        },
        {
          t: "Λίστα εργασιών",
          d: "Ανάθεση σε υπαλλήλους, με επιβεβαίωση.",
        },
        {
          t: "Πρόσβαση ιδιοκτήτη",
          d: "Οι πελάτες βλέπουν το άλογό τους στη δική τους εφαρμογή.",
        },
        {
          t: "Επαφές έκτακτης ανάγκης",
          d: "Πάντα εύκολα στη διάθεσή σας σε κρίσιμες στιγμές στον στάβλο.",
        },
      ],
      ctaLabel: "Δείτε την ενότητα ιππόδρομου",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Από WhatsApp, Excel και whiteboard στο EquiSight.",
      lead: "Συγκεκριμένα: έτσι αλλάζει η καθημερινή διαχείριση του αλόγου σας.",
      rows: [
        {
          before: "Ομάδες WhatsApp",
          after: "Δομημένες σημειώσεις ανά άλογο",
        },
        {
          before: "Φύλλα Excel",
          after: "Ζωντανός φάκελος αλόγου με ιστορικό",
        },
        {
          before: "Whiteboard στον στάβλο",
          after: "Κοινό πρόγραμμα στο τηλέφωνό σας",
        },
        {
          before: "Διάσπαρτες φωτογραφίες στη κάμερα",
          after: "Μέσα συνδεδεμένα με το άλογό σας",
        },
        {
          before: "Προφορικές συμφωνίες",
          after: "Εργασίες και υπενθυμίσεις με επιβεβαίωση",
        },
        {
          before: "Χαμένο χάρτινο διαβατήριο",
          after: "Έγγραφα πάντα στη διάθεσή σας",
        },
      ],
    },
    helper: {
      title: "Ποια εφαρμογή διαχείρισης αλόγου σας ταιριάζει;",
      lead: "Απαντήστε σε αυτές τις 5 ερωτήσεις και θα λάβετε μια ειλικρινή σύσταση — ακόμα κι αν αυτή δεν είναι πάντα το EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Έχετε ένα άλογο ή περισσότερα;",
          options: [
            {
              label: "Ένα άλογο",
              score: 1,
            },
            {
              label: "2–5 άλογα",
              score: 2,
            },
            {
              label: "Περισσότερα από 5 άλογα",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Διαχειρίζεστε άλογα πελατών ή τρίτων;",
          options: [
            {
              label: "Όχι, μόνο τα δικά μου άλογα",
              score: 0,
            },
            {
              label: "Μερικές φορές — για οικογένεια ή γνωστούς",
              score: 1,
            },
            {
              label: "Ναι, επαγγελματικά (στάβλος / ιππόδρομος)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Θέλετε να παρακολουθείτε εκτροφείο και κύηση;",
          options: [
            {
              label: "Δεν είναι σχετικό",
              score: 0,
            },
            {
              label: "Μερικές φορές — περιστασιακή εκτροφή",
              score: 1,
            },
            {
              label: "Ναι, είμαι (ή θα γίνω) εκτροφέας",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Συνεργάζεστε με εκπαιδευτή, φροντιστή ή επαγγελματία;",
          options: [
            {
              label: "Όχι, τα κάνω όλα μόνος/η μου",
              score: 0,
            },
            {
              label: "Ναι, με 1 άτομο",
              score: 1,
            },
            {
              label: "Ναι, με πολλά άτομα",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Θέλετε μόνο να καταγράφετε ή και να αποκτάτε πληροφορίες;",
          options: [
            {
              label: "Μόνο καταγραφή",
              score: 1,
            },
            {
              label: "Καταγραφή + προγραμματισμός",
              score: 2,
            },
            {
              label: "Καταγραφή + προγραμματισμός + πληροφορίες",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ένα απλό ημερολόγιο αρκεί — και μεγαλώνει μαζί σας.",
          body: "Για ένα άλογο χωρίς κοινή φροντίδα, κάθε εφαρμογή διαχείρισης αλόγου είναι κατάλληλη. Το EquiSight ξεκινά δωρεάν με 1 άλογο, οπότε δεν έχετε κανένα ρίσκο. Αν αργότερα θελήσετε να προσθέσετε περισσότερα άλογα, εκπαιδευτή ή εκτροφείο, όλα είναι ήδη εκεί.",
          cta: "Ξεκινήστε δωρεάν με 1 άλογο",
        },
        mid: {
          title: "Το EquiSight ταιριάζει καλά στην κατάστασή σας.",
          body: "Έχετε πολλαπλές ανάγκες (πολλαπλά άλογα, συνεργασία ή πληροφορίες). Οι περισσότεροι ανταγωνιστές καλύπτουν 1-2 ενότητες· το EquiSight τις συνδυάζει σε μία εφαρμογή, χωρίς να χρειάζεται να συνδέσετε ξεχωριστά εργαλεία.",
          cta: "Δείτε τι μπορεί να κάνει το EquiSight",
        },
        high: {
          title: "Το EquiSight είναι η πιο λογική επιλογή.",
          body: "Η κατάστασή σας συνδυάζει πολλαπλά άλογα, συνεργασία, εκτροφείο και/ή πληροφορίες. Αυτό είναι ακριβώς εκεί που το EquiSight κάνει τη διαφορά — χωρίς διάσπαρτα εργαλεία, αλλά ένας φάκελος αλόγου για τα πάντα και για όλους γύρω από το άλογο.",
          cta: "Ξεκινήστε δωρεάν με το EquiSight",
        },
      },
    },
    faqTitle: "Συχνές ερωτήσεις σχετικά με εφαρμογές διαχείρισης αλόγου",
    faq: [
      {
        q: "Ποια είναι η καλύτερη εφαρμογή διαχείρισης αλόγου;",
        a: "Η καλύτερη εφαρμογή διαχείρισης αλόγου εξαρτάται από την κατάστασή σας. Για απλή καταγραφή, πολλές εφαρμογές είναι κατάλληλες. Αν θέλετε να συνδυάσετε υγεία, εκπαίδευση, διατροφή, έγγραφα, εκτροφείο, προγραμματισμό και συνεργασία, το EquiSight έχει δημιουργηθεί ως ολοκληρωμένη λύση όπου τα πάντα συγκεντρώνονται σε έναν φάκελο.",
      },
      {
        q: "Μπορώ να διαχειριστώ πολλαπλά άλογα σε μία εφαρμογή;",
        a: "Ναι. Μια καλή εφαρμογή διαχείρισης αλόγου πρέπει να υποστηρίζει πολλαπλά άλογα, συμπεριλαμβανομένων ιδιοκτητών, φροντιστών, ρουτινών, εγγράφων, ραντεβού και υπενθυμίσεων ανά άλογο. Το EquiSight έχει σχεδιαστεί για αυτό από την πρώτη γραμμή κώδικα — τα άλογα είναι μεμονωμένοι φάκελοι, όχι σειρές σε μια λίστα.",
      },
      {
        q: "Είναι το EquiSight κατάλληλο και για εκτροφεία;",
        a: "Ναι. Το EquiSight μπορεί να ρυθμιστεί με λειτουργίες εκτροφείου όπως κύκλος φοράδας, ημερομηνία σπερματέγχυσης, έλεγχος κύησης, στοιχεία επιβήτορα, γενεαλογικό δέντρο, αναμενόμενη ημερομηνία γέννας και ανάπτυξη πουλαριού. Αυτός είναι ακριβώς ο τομέας όπου οι περισσότερες ανταγωνιστικές εφαρμογές δεν ανταποκρίνονται ή ανταποκρίνονται ελάχιστα.",
      },
      {
        q: "Μπορώ να μοιραστώ δεδομένα με τον εκπαιδευτή ή τον πεταλωτή μου;",
        a: "Ναι. Ο στόχος του EquiSight είναι να μπορούν οι σχετικές πληροφορίες να κοινοποιούνται με ασφάλεια σε άτομα γύρω από το άλογο — εκπαιδευτή, πεταλωτή, οδοντίατρο, κτηνίατρο, φυσιοθεραπευτή, φροντιστή ή ιδιοκτήτη. Κάθε άτομο λαμβάνει μόνο τα δικαιώματα που είναι απαραίτητα για τον ρόλο του.",
      },
      {
        q: "Γιατί να μη χρησιμοποιώ απλώς WhatsApp ή Excel;",
        a: "Το WhatsApp και το Excel λειτουργούν όσο τα πράγματα παραμένουν απλά. Μόλις έχετε πολλαπλά άλογα, ραντεβού, έγγραφα, θεραπείες, ιδιοκτήτες ή δεδομένα εκτροφείου, γίνονται επιρρεπή σε σφάλματα: οι πληροφορίες διασκορπίζονται, η αναζήτηση κοστίζει χρόνο και οι προφορικές συμφωνίες χάνονται. Μια εφαρμογή διαχείρισης αλόγου συγκεντρώνει τα πάντα ανά άλογο, με αυτόματες υπενθυμίσεις.",
      },
      {
        q: "Πόσο κοστίζει το EquiSight;",
        a: "Μπορείτε να ξεκινήσετε δωρεάν με 1 άλογο. Αν θέλετε να διαχειριστείτε περισσότερα άλογα, να ενεργοποιήσετε εκτροφείο ή να δώσετε πρόσβαση σε επαγγελματίες, υπάρχουν προσιτά Premium πλάνα. Δείτε τις τρέχουσες επιλογές στη σελίδα τιμολόγησης.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Λογισμικό αναπαραγωγής αλόγου: πλήρης σύγκριση 2026",
      description: "Συγκρίνετε λογισμικό αναπαραγωγής για άλογα: κύκλος φοράδας, κύηση, επιλογή επιβήτορα και πουλάρια. Ανακαλύψτε γιατί το EquiSight είναι η πλήρης εφαρμογή αναπαραγωγής.",
      keywords: [
        "λογισμικό αναπαραγωγής αλόγου",
        "εφαρμογή κύκλου φοράδας",
        "εφαρμογή κύησης φοράδας",
        "εφαρμογή καταχώρισης πουλαριού",
        "εφαρμογή στud book αλόγου",
        "προγραμματισμός οχείας αλόγου",
        "εφαρμογή επιλογής επιβήτορα",
      ],
    },
    hero: {
      eyebrow: "Οδηγός επιλογής · λογισμικό αναπαραγωγής",
      breadcrumbLabel: "Λογισμικό αναπαραγωγής",
      title: "Λογισμικό αναπαραγωγής για άλογα: η πλήρης σύγκριση για το 2026.",
      intro: "Μια φοράδα αναπαραγωγής αξίζει περισσότερα από μια γενική εφαρμογή διαχείρισης αλόγων. Συγκρίνετε τις λειτουργίες αναπαραγωγής των πιο γνωστών εργαλείων, ανακαλύψτε τι πρέπει πραγματικά να προσέχετε και επιλέξτε συνειδητά το λογισμικό που ταιριάζει στο εκτροφείο σας — μεγάλο ή μικρό.",
      pills: [
        {
          icon: "Baby",
          label: "Κύκλος φοράδας",
        },
        {
          icon: "Heart",
          label: "Έλεγχος κύησης",
        },
        {
          icon: "Sparkles",
          label: "Ανάπτυξη πουλαριού",
        },
        {
          icon: "FileText",
          label: "Stud book",
        },
      ],
      ctas: [
        {
          label: "Ξεκινήστε δωρεάν με την ενότητα αναπαραγωγής",
          href: "#start",
          primary: true,
        },
        {
          label: "Προς τον πίνακα σύγκρισης",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Γιατί μια συνηθισμένη εφαρμογή διαχείρισης αλόγων δεν αρκεί για την αναπαραγωγή.",
      lead: "Οι περισσότερες εφαρμογές ιππασίας σχεδιάστηκαν για ένα αθλητικό ή ψυχαγωγικό άλογο. Η αναπαραγωγή έχει εντελώς διαφορετικό ρυθμό: οίστρος, σπερματέγχυση, έλεγχος κύησης, υπέρηχοι, ημερολόγιο πουλαριών, γενεαλογικό δέντρο και πώληση. Ένα Excel χάνει τον έλεγχο μετά από 2 σεζόν — και με πολλές φοράδες χάνετε την εικόνα.",
      items: [
        "Πότε ήταν ο τελευταίος κύκλος της Bonita;",
        "Ποιος επιβήτορας έχει προγραμματιστεί για την οχεία την επόμενη σεζόν;",
        "Έχει κλειστεί ο υπέρηχος της 21ης ημέρας;",
        "Ποια πουλάρια του 2024 έχουν ήδη πουληθεί;",
        "Πού βρίσκεται το γενεαλογικό διάγραμμα μέχρι τον παππού από τη μητρική γραμμή;",
        "Πού είναι τα δείγματα DNA και τα στοιχεία διαβατηρίου;",
      ],
    },
    what: {
      title: "Τι είναι το λογισμικό αναπαραγωγής αλόγων;",
      lead: "Το λογισμικό αναπαραγωγής είναι ένας εξειδικευμένος φάκελος ανά φοράδα και επιβήτορα, σε συνδυασμό με ημερολόγιο αναπαραγωγικής σεζόν, προγραμματισμό κύησης, καταχώριση πουλαριών και εμφάνιση γενεαλογικού δέντρου. Όχι ένα γενικό ημερολόγιο αλόγων, αλλά ένα εργαλείο που κατανοεί τον κύκλο αναπαραγωγής: από τον πρώτο οίστρο μέχρι τον απογαλακτισμό.",
      targetGroupsTitle: "Σε ποιο τύπο εκτροφέα απευθύνεται το λογισμικό αναπαραγωγής;",
      targetGroups: [
        {
          icon: "Baby",
          title: "Ερασιτέχνης εκτροφέας (1-3 φοράδες)",
          body: "Μία ή δύο οχείες το χρόνο — επισκόπηση χωρίς ακροβατικά Excel.",
        },
        {
          icon: "Building2",
          title: "Μικρό εκτροφείο (4-10 φοράδες)",
          body: "Ετήσιο πλάνο αναπαραγωγής με κύκλο, σπερματέγχυση, ελέγχους κύησης και φάκελο πουλαριού.",
        },
        {
          icon: "Users",
          title: "Επαγγελματικό εκτροφείο (10+)",
          body: "Πολλαπλοί συνεργάτες, επιλογή επιβήτορα ανά φοράδα, πώληση και μάρκετινγκ.",
        },
        {
          icon: "Target",
          title: "Ιδιοκτήτης επιβήτορα",
          body: "Ιστορικό παραγγελιών, στατιστικά σπέρματος και ημερολόγιο ανά επιβήτορα.",
        },
        {
          icon: "Heart",
          title: "Μεταμόσχευση εμβρύου",
          body: "Δότρια + φοράδα παραλήπτης ως συνδεδεμένος φάκελος, ημερολόγιο ET.",
        },
        {
          icon: "ClipboardList",
          title: "Εγγραφή stud book",
          body: "Δείγματα DNA, έγγραφα διαβατηρίου και στοιχεία γενεαλογικού δέντρου.",
        },
      ],
    },
    criteria: {
      title: "Τι πρέπει να πληροί ένα καλό λογισμικό αναπαραγωγής;",
      lead: "Δεν είναι ίδια όλα τα «χαρακτηριστικά αναπαραγωγής» σε μια εφαρμογή αλόγων. Πέντε βασικοί τομείς όπου οι εκτροφείς χάνουν πολύ χρόνο — και όπου το λογισμικό κάνει πραγματικά τη διαφορά.",
      items: [
        {
          icon: "Calendar",
          title: "Κύκλος φοράδας & οίστρος",
          body: "Ημερήσιο ημερολόγιο, προβλεπτική ωορρηξία, ανακύλιση ανά κύκλο και αυτόματες υπενθυμίσεις.",
        },
        {
          icon: "Heart",
          title: "Σπερματέγχυση & έλεγχος κύησης",
          body: "Ημερομηνίες οχείας και σπερματέγχυσης, στοιχεία επιβήτορα, υπέρηχος 14ης ημέρας, 21ης ημέρας, 60ης ημέρας και προσδιορισμός φύλου.",
        },
        {
          icon: "Baby",
          title: "Ανάπτυξη πουλαριού",
          body: "Στοιχεία γέννησης, γράφημα βάρους, πρόγραμμα αποπαρασίτωσης, απογαλακτισμός, καταχώριση διαβατηρίου.",
        },
        {
          icon: "FileText",
          title: "Γενεαλογικό δέντρο & έγγραφα",
          body: "Εμφάνιση γενεαλογικού δέντρου έως 4-5 γενιές, DNA, αριθμοί διαβατηρίου και κατάσταση stud book.",
        },
        {
          icon: "Target",
          title: "Επιλογή επιβήτορα & ταίριασμα",
          body: "Φιλτράρισμα ανά κλάδο, γραμμές, στοιχεία επιβήτορα και ιστορική επιτυχία — όχι μόνο αυτό που προωθεί ένας ιδιοκτήτης επιβήτορα.",
        },
        {
          icon: "Share2",
          title: "Συνεργασία κτηνιάτρου/σπερματεγχύτη",
          body: "Υπέρηχοι, δείγματα και καταστάσεις μοιράζονται απευθείας με την κλινική που εργάζεται με τις φοράδες σας.",
        },
      ],
    },
    comparison: {
      title: "EquiSight εναντίον άλλου λογισμικού αναπαραγωγής.",
      lead: "Τα αποτελέσματα αναζήτησης για λογισμικό αναπαραγωγής αλόγων εμφανίζουν συχνά γενικές εφαρμογές αλόγων που αναφέρουν την αναπαραγωγή σε μια πρόταση. Συγκρίνουμε με ειλικρίνεια ποια εργαλεία έχουν πραγματικά πλήρη ροή αναπαραγωγής.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Δωρεάν εκκίνηση",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Καταγραφή κύκλου φοράδας",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ημερομηνία σπερματέγχυσης + επιβήτορας",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Υπέρηχοι & έλεγχος κύησης",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Αναμενόμενη ημερομηνία γέννησης",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Φάκελος πουλαριού (βάρος/ανάπτυξη)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Γενεαλογικό δέντρο έως 4-5 γενιές",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA & καταχώριση διαβατηρίου",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Επιλογή επιβήτορα / ταίριασμα",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / μεταμόσχευση εμβρύου",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Επισκόπηση πολλαπλών φοράδων",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Κινητό (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Κοινοποίηση με κτηνίατρο",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Ενσωματωμένο με γενικό φάκελο",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Πώληση & μάρκετινγκ πουλαριών",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Σύγκριση βάσει δημόσια διαθέσιμων χαρακτηριστικών τον Ιανουάριο του 2026. Το EquineGenie είναι ισχυρό στην αναπαραγωγή, αλλά υστερεί σε κινητό + γενική διαχείριση αλόγων. Το EquiSight συνδυάζει και τα δύο.",
    },
    why: {
      title: "Γιατί το EquiSight εξυπηρετεί διαφορετικά τους εκτροφείς.",
      lead: "Πολλοί εκτροφείς χρησιμοποιούν ξεχωριστό λογισμικό αναπαραγωγής και μια διαφορετική εφαρμογή διαχείρισης αλόγων. Το EquiSight συνδυάζει και τα δύο — χωρίς εναλλαγή μεταξύ εφαρμογών ή διπλή εισαγωγή δεδομένων.",
      points: [
        {
          icon: "Heart",
          title: "Η φοράδα αναπαραγωγής παραμένει και απλό άλογο",
          body: "Η φοράδα αναπαραγωγής έχει τόσο φάκελο αναπαραγωγής όσο και κανονικό φάκελο αλόγου — υγεία, εμβολιασμοί, πεταλωτής. Μία εφαρμογή, όλες οι ενότητες.",
        },
        {
          icon: "Sparkles",
          title: "Προβλεπτικό αντί για αντιδραστικό",
          body: "Πρόβλεψη κύκλου, υπενθυμίσεις ορόσημων κύησης και ημερολόγιο πουλαριών — αυτόματα με βάση τα δεδομένα σας.",
        },
        {
          icon: "Share2",
          title: "Όλοι γύρω από την αναπαραγωγή",
          body: "Σπερματεγχύτης, ιδιοκτήτης επιβήτορα, κτηνίατρος, αγοραστής, stud book — όλοι με πρόσβαση στα κατάλληλα δικαιώματα.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Ανά κλάδο · από τον κύκλο μέχρι τον απογαλακτισμό",
      title: "Τι περιέχει ένας φάκελος αναπαραγωγής στο EquiSight.",
      lead: "Για κάθε φοράδα λαμβάνετε έναν πλήρη φάκελο αναπαραγωγής, συνδεδεμένο με τον κανονικό φάκελο αλόγου της.",
      items: [
        "Ημερήσιο ημερολόγιο κύκλου με πρόβλεψη",
        "Σπερματέγχυση/οχεία + στοιχεία επιβήτορα",
        "Χρονολόγιο υπερήχων (14/21/60 ημέρες + φύλο)",
        "Ορόσημα κύησης με αυτόματες υπενθυμίσεις",
        "Αναμενόμενη ημερομηνία γέννησης και προετοιμασία",
        "Φάκελος πουλαριού από τη γέννηση",
        "Γενεαλογικό δέντρο έως παππούδες με πλοήγηση κλικ",
        "Δείγμα DNA, διαβατήριο, κατάσταση stud book",
        "Αγωγός πώλησης με ενδιαφερόμενους",
        "Ιστορικό επιλογής επιβήτορα ανά φοράδα",
      ],
      ctaLabel: "Δείτε την ενότητα αναπαραγωγής",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Για ολόκληρο το εκτροφείο",
      title: "Επισκόπηση για πολλαπλές φοράδες και επιβήτορες.",
      lead: "Όταν εκτρέφετε περισσότερες από 2-3 φοράδες, η επισκόπηση όλων των κύκλων και των κυήσεων γίνεται κρίσιμη.",
      cards: [
        {
          t: "Πίνακας κύκλων",
          d: "Όλες οι φοράδες δίπλα-δίπλα, με στάδιο κύκλου και επόμενη ενέργεια.",
        },
        {
          t: "Αγωγός κύησης",
          d: "Ποιες φοράδες βρίσκονται σε ποιο ορόσημο κύησης;",
        },
        {
          t: "Ημερολόγιο πουλαριών",
          d: "Αναμενόμενες γεννήσεις ανά μήνα, με ανάλογη λογιστική υποστήριξη.",
        },
        {
          t: "Χαρτοφυλάκιο επιβητόρων",
          d: "Δικοί σας επιβήτορες ή σταθεροί σπερματεγχύτες με ιστορικό παραγγελιών.",
        },
        {
          t: "Γράφημα γενεαλογικού δέντρου",
          d: "Ανάλυση προγόνων σε πολλαπλές γενιές και γραμμές.",
        },
        {
          t: "Πίνακας πωλήσεων",
          d: "Ποια πουλάρια έχουν πουληθεί, κρατηθεί ή είναι ακόμα διαθέσιμα.",
        },
      ],
    },
    beforeAfter: {
      title: "Από Excel + ημερολόγιο στο EquiSight αναπαραγωγής.",
      lead: "Συγκεκριμένα: έτσι αλλάζει η αναπαραγωγική σας σεζόν.",
      rows: [
        {
          before: "Κύκλος σε χαλαρή σημείωση",
          after: "Ημερήσιο ημερολόγιο με πρόβλεψη",
        },
        {
          before: "Υπέρηχοι μέσω WhatsApp στον σπερματεγχύτη",
          after: "Κοινός φάκελος με φωτογραφίες",
        },
        {
          before: "Ημερομηνία κύησης στο ημερολόγιο",
          after: "Αυτόματες υπενθυμίσεις ορόσημων",
        },
        {
          before: "Διαβατήριο πουλαριού σε συρτάρι",
          after: "Έγγραφο συνδεδεμένο με προφίλ πουλαριού",
        },
        {
          before: "Γενεαλογικό δέντρο σε χαρτί",
          after: "Κλικαρισμένο γενεαλογικό δέντρο έως 4-5 γενιές",
        },
        {
          before: "Αγγελία πώλησης στο Marktplaats",
          after: "Αγωγός πώλησης με λίστα ενδιαφερομένων",
        },
      ],
    },
    helper: {
      title: "Ποιο λογισμικό αναπαραγωγής σας ταιριάζει;",
      lead: "5 ερωτήσεις για να δείτε αν χρειάζεστε μια πλήρη εφαρμογή αναπαραγωγής ή αν αρκεί ένα εργαλείο χόμπι.",
      questions: [
        {
          id: "mares",
          q: "Πόσες φοράδες αναπαραγωγής διαχειρίζεστε;",
          options: [
            {
              label: "1 φοράδα",
              score: 1,
            },
            {
              label: "2-5 φοράδες",
              score: 2,
            },
            {
              label: "Περισσότερες από 5 φοράδες",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Πόσο συχνά εκτρέφετε ανά έτος;",
          options: [
            {
              label: "Περιστασιακά (κάθε μερικά χρόνια)",
              score: 0,
            },
            {
              label: "Κάθε χρόνο 1-2 οχείες",
              score: 2,
            },
            {
              label: "Κάθε χρόνο 3+ οχείες",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Πώς σπερματεγχύετε/οχεύετε;",
          options: [
            {
              label: "Φυσική οχεία",
              score: 1,
            },
            {
              label: "Τεχνητή σπερματέγχυση φρέσκου/ψυγμένου σπέρματος",
              score: 2,
            },
            {
              label: "ET ή κατεψυγμένο σπέρμα",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Συνεργάζεστε με κτηνίατρο/σπερματεγχύτη;",
          options: [
            {
              label: "Ένα σταθερό άτομο",
              score: 1,
            },
            {
              label: "Πολλαπλές κλινικές",
              score: 2,
            },
            {
              label: "Διεθνές δίκτυο",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Τι παρακολουθείτε τώρα;",
          options: [
            {
              label: "Excel ή χαρτί",
              score: 1,
            },
            {
              label: "Γενική εφαρμογή διαχείρισης αλόγων",
              score: 2,
            },
            {
              label: "Τίποτα δομημένο",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ένα εργαλείο χόμπι ή Excel αρκεί — αλλά το EquiSight παραμένει χρήσιμο.",
          body: "Για 1 φοράδα με φυσική οχεία κάθε μερικά χρόνια, μια εκτεταμένη ενότητα αναπαραγωγής είναι υπερβολή. Το EquiSight ξεκινά δωρεάν και ενεργοποιείτε την ενότητα αναπαραγωγής μόνο για το έτος που εκτρέφετε — χωρίς υποχρέωση αναβάθμισης.",
          cta: "Ξεκινήστε δωρεάν",
        },
        mid: {
          title: "Το EquiSight αναπαραγωγής είναι το κατάλληλο εργαλείο.",
          body: "Έχετε πολλαπλές φοράδες ή πολλαπλές μεθόδους αναπαραγωγής — για αυτά δεν έχουν σχεδιαστεί γενικές εφαρμογές αλόγων. Το EquiSight συνδυάζει αναπαραγωγή + γενική φροντίδα, ώστε να μην εναλλάσσετε δύο εργαλεία.",
          cta: "Δείτε την ενότητα αναπαραγωγής",
        },
        high: {
          title: "Το EquiSight είναι φτιαγμένο για το εκτροφείο σας.",
          body: "Πολλαπλές φοράδες, ET ή κατεψυγμένο σπέρμα, διεθνής ομάδα — τα περισσότερα εργαλεία αδυνατούν εδώ. Το EquiSight κλιμακώνεται έως επίπεδο εκτροφείου χωρίς να συσσωρεύετε επιπλέον άδειες.",
          cta: "Μιλήστε μαζί μας για ένα πλάνο Εκτροφείου",
        },
      },
    },
    faqTitle: "Συχνές ερωτήσεις για το λογισμικό αναπαραγωγής",
    faq: [
      {
        q: "Ποιο είναι το καλύτερο λογισμικό αναπαραγωγής αλόγων;",
        a: "Για 1 φοράδα χωρίς περίπλοκη μέθοδο αναπαραγωγής αρκούν πολλά εργαλεία. Από 2-3 φοράδες, χρήση τεχνητής σπερματέγχυσης ή ET, ή συνεργασία με κτηνίατρο και stud book, μια πλήρης ενότητα αναπαραγωγής γίνεται κρίσιμη. Το EquiSight συνδυάζει αναπαραγωγή με γενική διαχείριση αλόγων σε μια εφαρμογή, ώστε να μην χρειάζεται εναλλαγή.",
      },
      {
        q: "Ποιες λειτουργίες αναπαραγωγής χρειάζομαι πραγματικά;",
        a: "Ελάχιστο: ημερολόγιο κύκλου, στοιχεία σπερματέγχυσης/οχείας, ορόσημα ελέγχου κύησης και φάκελος πουλαριού. Προαιρετικά αλλά ισχυρά: εμφάνιση γενεαλογικού δέντρου, αρχείο επιλογής επιβήτορα, DNA/διαβατήριο και αγωγός πώλησης.",
      },
      {
        q: "Μπορεί το EquiSight να προβλέψει τον κύκλο μιας φοράδας;",
        a: "Ναι. Το EquiSight χρησιμοποιεί προηγούμενα δεδομένα κύκλου για να εμφανίσει την προβλεπόμενη ωορρηξία, ώστε να προγραμματίζετε τη σπερματέγχυση ή οχεία τη σωστή στιγμή — χωρίς καθημερινό παζλ.",
      },
      {
        q: "Λειτουργεί το EquiSight και για μεταμόσχευση εμβρύου;",
        a: "Ναι. Η δότρια και η φοράδα παραλήπτης λαμβάνουν συνδεδεμένους φακέλους, ημερολόγιο ET και κοινά ορόσημα με την κλινική. Έτσι δεν χάνετε χρονολόγιο στη σύνθετη ροή ET.",
      },
      {
        q: "Μπορώ να εισαγάγω τα υπάρχοντα δεδομένα αναπαραγωγής μου;",
        a: "Μπορείτε να εισάγετε χειροκίνητα κύκλους, οχείες και δεδομένα πουλαριών ή μαζικά μέσω CSV. Για ενεργά εκτροφεία βοηθάμε με εφάπαξ μετεγκατάσταση αν έχετε δεδομένα πολλών σεζόν.",
      },
      {
        q: "Πώς μοιράζομαι τον φάκελο με τον κτηνίατρο ή τον σπερματεγχύτη μου;",
        a: "Κάθε άτομο λαμβάνει πρόσβαση με έναν ρόλο: κτηνίατρος, σπερματεγχύτης, ιδιοκτήτης επιβήτορα ή υπάλληλος stud book. Ο καθένας βλέπει μόνο τις πληροφορίες που είναι απαραίτητες για τον ρόλο του — δεν απαιτείται πλήρης πρόσβαση.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Λογισμικό ιππικού κέντρου: πλήρης σύγκριση & οδηγός επιλογής 2026",
      description: "Συγκρίνετε λογισμικό για ιππικά κέντρα: μαθήματα, ιππείς, άλογα και διαχείριση. Ανακαλύψτε ποια εφαρμογή ταιριάζει στο ιππικό κέντρο ή φάρμα σύνταξης ίππων σας.",
      keywords: [
        "λογισμικό ιππικού κέντρου",
        "εφαρμογή διαχείρισης στάβλου",
        "διαχείριση ιππικού κέντρου",
        "προγραμματισμός μαθημάτων ιππικής",
        "λογισμικό φάρμας σύνταξης ίππων",
        "διαχείριση ιππέων",
        "διαχείριση αλόγων ιππικό κέντρο",
      ],
    },
    hero: {
      eyebrow: "Οδηγός επιλογής · λογισμικό ιππικού κέντρου",
      breadcrumbLabel: "Λογισμικό ιππικού κέντρου",
      title: "Λογισμικό ιππικού κέντρου: ο πλήρης οδηγός επιλογής για ιππικά κέντρα και φάρμες σύνταξης ίππων.",
      intro: "Προγραμματισμός μαθημάτων, διαχείριση ιππέων, φροντίδα αλόγων, τιμολόγηση και επικοινωνία — ένα καλό λογισμικό ιππικού κέντρου τα συγκεντρώνει όλα. Συγκρίνετε τις πιο γνωστές επιλογές και ανακαλύψτε ποια ταιριάζει στον στάβλο ή το ιππικό κέντρο σας.",
      pills: [
        {
          icon: "Calendar",
          label: "Προγραμματισμός μαθημάτων",
        },
        {
          icon: "Users",
          label: "Ιππείς & πελάτες",
        },
        {
          icon: "Heart",
          label: "Φροντίδα αλόγων",
        },
        {
          icon: "CreditCard",
          label: "Τιμολόγηση",
        },
      ],
      ctas: [
        {
          label: "Ζητήστε μια επίδειξη",
          href: "#start",
          primary: true,
        },
        {
          label: "Στον πίνακα σύγκρισης",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Γιατί τα διάσπαρτα εργαλεία επιβραδύνουν ένα ιππικό κέντρο.",
      lead: "Τα περισσότερα ιππικά κέντρα λειτουργούν με ένα μωσαϊκό εργαλείων: προγραμματισμός μαθημάτων σε whiteboard, καταχώριση ιππέων σε Excel, τιμολόγηση σε ξεχωριστό εργαλείο, φροντίδα αλόγων στο WhatsApp και επικοινωνία με ιδιοκτήτες μέσω προσωπικών μηνυμάτων. Σε μια πολυάσχολη εβδομάδα προκύπτουν διπλές κρατήσεις, ξεχασμένα τιμολόγια ή άλογα που δεν ξέρουν ποιον ιππέα θα δεχτούν.",
      items: [
        "Ποιος έχει μάθημα τώρα με την Ιασμίνα;",
        "Ποιος ιππέας δεν έχει πληρώσει για τον Μάρτιο;",
        "Ποιο άλογο δεν μπορεί να χρησιμοποιηθεί αυτή την εβδομάδα;",
        "Ποιες είναι οι επαφές έκτακτης ανάγκης των μαθητών;",
        "Έχει λάβει ο ιδιοκτήτης του Stardust το τιμολόγιο του πεταλωτή;",
        "Ποιο άλογο βρίσκεται σε ποιο κελί;",
      ],
    },
    what: {
      title: "Τι είναι το λογισμικό ιππικού κέντρου;",
      lead: "Το λογισμικό ιππικού κέντρου συνδυάζει προγραμματισμό μαθημάτων, διαχείριση ιππέων, φροντίδα αλόγων, τιμολόγηση και επικοινωνία σε ένα εργαλείο. Χωρίς ακροβατισμούς στο Excel ή χάος στο WhatsApp — ένα μέρος όπου το ιππικό κέντρο λειτουργεί και ιδιοκτήτες/ιππείς παρακολουθούν.",
      targetGroupsTitle: "Για ποιο τύπο επιχείρησης προορίζεται το λογισμικό ιππικού κέντρου;",
      targetGroups: [
        {
          icon: "Building2",
          title: "Μικρό ιππικό κέντρο (1-15 άλογα)",
          body: "Κυρίως προγραμματισμός μαθημάτων και πληρωμές — διαχείριση χωρίς πονοκέφαλο.",
        },
        {
          icon: "Users",
          title: "Μεσαίο ιππικό κέντρο (15-40 άλογα)",
          body: "Πολλοί εκπαιδευτές, προγραμματισμός μαθημάτων + πρόγραμμα αλόγων + διαχείριση ιππέων.",
        },
        {
          icon: "ClipboardList",
          title: "Μεγάλος στάβλος ιππασίας & σύνταξης (40+)",
          body: "Πλήρης λειτουργία συμπεριλαμβανομένης τιμολόγησης, προγραμματισμού διατροφής και πεταλωτή.",
        },
        {
          icon: "Heart",
          title: "Φάρμα σύνταξης ίππων",
          body: "Πύλη ιδιοκτητών, ατομικές οδηγίες φροντίδας, κοινό ημερολόγιο.",
        },
        {
          icon: "Target",
          title: "Στάβλος εκπαίδευσης υπεράσπισης",
          body: "Προγραμματισμός αγώνων, εκπαίδευση ανά άλογο, επικοινωνία με πελάτες.",
        },
        {
          icon: "FileText",
          title: "Επαγγελματίες ιππικής",
          body: "Μείγμα μαθημάτων + σύνταξης + clinic + εμπορίου — τα πάντα από ένα σύστημα.",
        },
      ],
    },
    criteria: {
      title: "Ποια κριτήρια πρέπει να πληροί ένα καλό λογισμικό ιππικού κέντρου;",
      lead: "Μια ωραία εφαρμογή δεν σημαίνει τίποτα αν οι υπάλληλοί σας δεν θέλουν να τη χρησιμοποιήσουν. Πέντε πρακτικά κριτήρια που κάνουν τη διαφορά μεταξύ επιτυχίας και απογοήτευσης.",
      items: [
        {
          icon: "Calendar",
          title: "Προγραμματισμός μαθημάτων πολλών επιπέδων",
          body: "Αρχάριοι/προχωρημένοι, δρεσάζ/άλματα, συνδέσεις αλόγου-ιππέα και ημερολόγια εκπαιδευτών — όλα ορατά παράλληλα.",
        },
        {
          icon: "Users",
          title: "Διαχείριση ιππέων",
          body: "Προφίλ, επίπεδο, συνδρομή, κάρτα μαθημάτων και συνδέσεις οικογενειακών μελών για νεαρούς ιππείς.",
        },
        {
          icon: "Heart",
          title: "Πρόγραμμα αλόγων",
          body: "Πόσο συχνά χρησιμοποιείται κάθε άλογο, με περιόδους ανάπαυσης, τραυματισμού και αποκατάστασης.",
        },
        {
          icon: "CreditCard",
          title: "Τιμολόγηση & συνδρομές",
          body: "Μηνιαίες συνδρομές, κάρτες μαθημάτων, μεμονωμένα μαθήματα και αυτόματη χρέωση.",
        },
        {
          icon: "Share2",
          title: "Πύλη ιδιοκτητών (φάρμα σύνταξης)",
          body: "Οι ιδιοκτήτες βλέπουν το άλογό τους στη δική τους εφαρμογή — ημερολόγιο, έξοδα, πεταλωτή και σημειώσεις χωρίς τηλεφώνημα.",
        },
        {
          icon: "Bell",
          title: "Επικοινωνία & υπενθυμίσεις",
          body: "Αυτόματες υπενθυμίσεις μαθημάτων, ειδοποιήσεις πληρωμής, ανακοινώσεις πεταλωτή — χωρίς μηνύματα.",
        },
      ],
    },
    comparison: {
      title: "EquiSight έναντι άλλου λογισμικού ιππικού κέντρου.",
      lead: "Πολλά εργαλεία για ιππικά κέντρα είναι ισχυρά στον προγραμματισμό μαθημάτων ή στην τιμολόγηση, αλλά σπάνια στη φροντίδα αλόγων και την επικοινωνία με ιδιοκτήτες ταυτόχρονα. Τα συγκρίνουμε αντικειμενικά.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Δωρεάν εκκίνηση / δοκιμαστική περίοδος",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Προγραμματισμός μαθημάτων",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Πολλοί εκπαιδευτές",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Διαχείριση ιππέων",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Πρόγραμμα αλόγων",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Φροντίδα αλόγων (εμβολιασμός/πεταλωτής)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Κάρτα μαθημάτων / συνδρομή",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ηλεκτρονικές πληρωμές",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Αυτόματη τιμολόγηση",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Πύλη ιδιοκτητών (σύνταξη)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ενσωμάτωση πεταλωτή/κτηνιάτρου",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Υπενθυμίσεις WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Κινητό (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Προγραμματισμός αγώνων",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Κατάλληλο για φάρμα σύνταξης",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Σύγκριση βάσει δημοσίως διαθέσιμων λειτουργιών τον Ιανουάριο 2026. Το Stalmanager είναι ισχυρό στη διαχείριση, ενώ το EquiSight ξεχωρίζει στη ροή σύνταξης ίππων + φροντίδα αλόγων + πύλη ιδιοκτητών.",
    },
    why: {
      title: "Γιατί το EquiSight είναι διαφορετικό για ιππικά κέντρα και φάρμες σύνταξης.",
      lead: "Το EquiSight πηγαίνει πέρα από έναν απλό προγραμματιστή μαθημάτων. Βλέπουμε ένα ιππικό κέντρο ως μια πλήρη επιχείρηση: άλογα, άνθρωποι, επικοινωνία και χρήματα — όλα αλληλοεξαρτώμενα.",
      points: [
        {
          icon: "Heart",
          title: "Το άλογο στο κέντρο, όχι το ημερολόγιο",
          body: "Κάθε άλογο έχει τον δικό του φάκελο. Συμμετοχή σε μαθήματα, υγεία, πεταλωτής και αγώνες σε ένα χρονολόγιο — όχι σε 3 ξεχωριστά εργαλεία.",
        },
        {
          icon: "Share2",
          title: "Οι ιδιοκτήτες ενημερώνονται χωρίς τηλεφώνημα",
          body: "Οι ιδιοκτήτες φάρμας σύνταξης έχουν τη δική τους προβολή: έξοδα, προγραμματισμός, φωτογραφίες και σημειώσεις — εξοικονομεί 5-10 τηλεφωνήματα την εβδομάδα.",
        },
        {
          icon: "Bell",
          title: "Αυτόματη επικοινωνία",
          body: "Υπενθύμιση μαθήματος, υπενθύμιση εμβολιασμού, τιμολόγιο — αυτόματα, μέσω εφαρμογής/email/SMS. Χωρίς άλλα broadcast WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Για τη φάρμα σύνταξης ίππων",
      title: "Τι προσφέρει το EquiSight σε μια φάρμα σύνταξης ίππων.",
      lead: "Οι φάρμες σύνταξης ίππων έχουν μοναδικές προκλήσεις που το συνηθισμένο λογισμικό ιππικού κέντρου δεν λύνει.",
      cards: [
        {
          t: "Πύλη ιδιοκτητών",
          d: "Κάθε ιδιοκτήτης βλέπει μόνο το άλογό του, το ημερολόγιο και τα έξοδά του.",
        },
        {
          t: "Οδηγίες φροντίδας ανά άλογο",
          d: "Διατροφή, χοντρή τροφή, συμπληρώματα, πρόγραμμα κουβέρτας — ορατά για τον στάβλο.",
        },
        {
          t: "Κοινό ημερολόγιο",
          d: "Πεταλωτής, κτηνίατρος και επίσκεψη ιδιοκτήτη σε μια προβολή.",
        },
        {
          t: "Κόστη κατανάλωσης ανά άλογο",
          d: "Στρωμνή, τροφή, συμπυκνωμένες τροφές χρεώνονται ανά ιδιοκτήτη.",
        },
        {
          t: "Επαφές έκτακτης ανάγκης αλόγου",
          d: "Ιδιοκτήτης + κτηνίατρος + πεταλωτής πάντα εύκολα προσβάσιμοι για τον στάβλο.",
        },
        {
          t: "Διαχείριση βοσκής",
          d: "Ποια άλογα πηγαίνουν σε βοσκή, σε ανάπαυση ή αποκατάσταση;",
        },
      ],
    },
    beforeAfter: {
      title: "Από whiteboard + Excel στο EquiSight.",
      lead: "Συγκεκριμένα: έτσι αλλάζει μια εργάσιμη εβδομάδα στο ιππικό κέντρο.",
      rows: [
        {
          before: "Whiteboard με το πρόγραμμα μαθημάτων",
          after: "Ζωντανό πρόγραμμα ανά εκπαιδευτή",
        },
        {
          before: "Excel με ιππείς + σημειώσεις μαθημάτων",
          after: "CRM πελατών με ιστορικό μαθημάτων",
        },
        {
          before: "WhatsApp στους ιδιοκτήτες",
          after: "Πύλη ιδιοκτητών για το άλογό τους",
        },
        {
          before: "Μηνιαία χρέωση χειροκίνητα",
          after: "Αυτόματη τιμολόγηση + iDEAL",
        },
        {
          before: "Φροντίδα αλόγου σε πινακίδα χαρτιού",
          after: "Οδηγίες φροντίδας ανά άλογο, κοινές",
        },
        {
          before: "Προφορική συμφωνία με πεταλωτή",
          after: "Προγραμματισμός πεταλωτή με επιβεβαιώσεις",
        },
      ],
    },
    helper: {
      title: "Ποιο λογισμικό ιππικού κέντρου σας ταιριάζει;",
      lead: "5 ερωτήσεις για να δείτε αν το EquiSight είναι η κατάλληλη πλατφόρμα για το ιππικό κέντρο ή τη φάρμα σύνταξης ίππων σας.",
      questions: [
        {
          id: "size",
          q: "Πόσα άλογα έχετε στην επιχείρησή σας;",
          options: [
            {
              label: "Λιγότερα από 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Περισσότερα από 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Ποια είναι η κύρια δραστηριότητά σας;",
          options: [
            {
              label: "Κυρίως μαθήματα ιππασίας",
              score: 1,
            },
            {
              label: "Φάρμα σύνταξης ίππων",
              score: 3,
            },
            {
              label: "Μείγμα μαθημάτων + σύνταξης",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Με πόσους εκπαιδευτές εργάζεστε;",
          options: [
            {
              label: "Μόνο εγώ",
              score: 1,
            },
            {
              label: "2-3 εκπαιδευτές",
              score: 2,
            },
            {
              label: "4 ή περισσότεροι",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Πώς διαχειρίζεστε την τιμολόγησή σας τώρα;",
          options: [
            {
              label: "Χειροκίνητα (Word/Excel)",
              score: 3,
            },
            {
              label: "Ξεχωριστό πρόγραμμα λογιστικής",
              score: 2,
            },
            {
              label: "Ενσωματωμένο στο εργαλείο μαθημάτων",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Πώς επικοινωνείτε με τους ιδιοκτήτες;",
          options: [
            {
              label: "Προσωπικά / WhatsApp",
              score: 3,
            },
            {
              label: "Email + WhatsApp",
              score: 2,
            },
            {
              label: "Πύλη ιδιοκτητών στο εργαλείο",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ένα απλό εργαλείο ή Excel μπορεί να αρκεί προς το παρόν — αλλά το EquiSight μεγαλώνει μαζί σας.",
          body: "Για μια μικρή σχολή με έναν εκπαιδευτή και λίγη σύνταξη, ένα πλήρες πακέτο δεν είναι απαραίτητο αμέσως. Το EquiSight ξεκινά δωρεάν και μεγαλώνει με το ιππικό κέντρο σας — χωρίς επίπονη μετεγκατάσταση μετά από μερικά χρόνια.",
          cta: "Ξεκινήστε δωρεάν",
        },
        mid: {
          title: "Το EquiSight είναι μια λογική αναβάθμιση για το ιππικό κέντρο σας.",
          body: "Πολλοί εκπαιδευτές, μείγμα μαθημάτων και σύνταξης, ή τιμολόγηση που είναι ξεχωριστή — το EquiSight τα συνδυάζει σε μια ενιαία ροή εργασίας. Ιδιαίτερα η πύλη ιδιοκτητών εξοικονομεί πολλή ad-hoc επικοινωνία.",
          cta: "Ζητήστε μια επίδειξη",
        },
        high: {
          title: "Το EquiSight είναι φτιαγμένο για την κλίμακά σας.",
          body: "Φάρμα σύνταξης + μαθήματα + πολλοί εκπαιδευτές είναι ακριβώς εκεί που το EquiSight ξεχωρίζει από τα κλασικά εργαλεία ιππικού κέντρου. Η πύλη ιδιοκτητών και η ενσωμάτωση φροντίδας αλόγων εξοικονομούν ώρες διαχείρισης και επικοινωνίας κάθε εβδομάδα.",
          cta: "Κλείστε επίδειξη για τον στάβλο σας",
        },
      },
    },
    faqTitle: "Συχνές ερωτήσεις για το λογισμικό ιππικού κέντρου",
    faq: [
      {
        q: "Ποιο είναι το καλύτερο λογισμικό ιππικού κέντρου;",
        a: "Για αμιγή προγραμματισμό μαθημάτων υπάρχουν αρκετές καλές επιλογές. Από τη στιγμή που χρειάζεστε φάρμα σύνταξης, πολλούς εκπαιδευτές ή παρακολούθηση φροντίδας αλόγων, το EquiSight γίνεται η πλήρης λύση — χωρίς ταχυδακτυλουργίες εργαλείων, τα πάντα σε ένα μέρος.",
      },
      {
        q: "Μπορώ να εισαγάγω υπάρχοντες πελάτες και μαθήματα;",
        a: "Ναι. Τα στοιχεία πελατών και τα προγράμματα μαθημάτων μπορούν να εισαχθούν μέσω CSV. Βοηθάμε ενεργά ιππικά κέντρα με εφάπαξ μετεγκατάσταση ώστε να μην χρειαστεί να εισάγετε 200 ιππείς χειροκίνητα.",
      },
      {
        q: "Λειτουργεί και για φάρμα σύνταξης χωρίς μαθήματα;",
        a: "Ναι. Η λειτουργία φάρμας σύνταξης απενεργοποιεί τα μαθήματα και εστιάζει στην πύλη ιδιοκτητών, διατροφή/φροντίδα, προγραμματισμό πεταλωτή και χρέωση εξόδων ανά άλογο.",
      },
      {
        q: "Μπορούν οι ιππείς να εγγραφούν και να πληρώσουν μόνοι τους;",
        a: "Ναι. Οι ιππείς μπορούν μέσω του δικού τους λογαριασμού να δουν ποια μαθήματα είναι διαθέσιμα, να εγγραφούν, να πληρώσουν δίδακτρα με iDEAL και να αγοράσουν κάρτες μαθημάτων.",
      },
      {
        q: "Τι ισχύει για το απόρρητο των δεδομένων αλόγων και ιδιοκτητών;",
        a: "Κάθε άτομο έχει έναν ρόλο (ιδιοκτήτης, ιππέας, εκπαιδευτής, υπάλληλος). Ανά ρόλο βλέπετε μόνο ό,τι χρειάζεστε. Οι ιδιοκτήτες βλέπουν μόνο το δικό τους άλογο, οι ιππείς μόνο τα δικά τους μαθήματα.",
      },
      {
        q: "Μπορεί το EquiSight να συνδεθεί με το λογισμικό λογιστικής μου;",
        a: "Ναι, διαθέσιμες είναι συνδέσεις με Exact, Moneybird και e-Boekhouden. Τα τιμολόγια μεταφέρονται τότε αυτόματα στη λογιστική σας.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Εφαρμογή εκπαιδευτή αλόγου: σύγκριση & οδηγός επιλογής για coaches 2026",
      description: "Συγκρίνετε εφαρμογές εκπαιδευτή για άλογο και αναβάτη: ημερολόγιο προπόνησης, βίντεο, στόχοι, ανάλυση πρωτοκόλλου και διαχείριση πελατών. Βρείτε το κατάλληλο εργαλείο για coaches.",
      keywords: [
        "εφαρμογή εκπαιδευτή αλόγου",
        "εφαρμογή εκπαιδευτή ιππασίας",
        "εφαρμογή προπόνησης αλόγου",
        "εφαρμογή coaching αναβάτη",
        "ημερολόγιο προπόνησης αλόγου",
        "ανάλυση πρωτοκόλλου δρεσάρ",
        "λογισμικό εκπαιδευτή αλόγων",
      ],
    },
    hero: {
      eyebrow: "Οδηγός επιλογής · λογισμικό εκπαιδευτή",
      breadcrumbLabel: "Εφαρμογή εκπαιδευτή",
      title: "Εφαρμογή εκπαιδευτή αλόγου: πλήρης οδηγός επιλογής για εκπαιδευτές και coaches.",
      intro: "Ένας εκπαιδευτής ή καθηγητής ιππασίας διαχειρίζεται συνδυασμούς αλόγου-αναβάτη, μαθήματα, βίντεο, στόχους και αγώνες. Συγκρίνετε τις καλύτερες εφαρμογές εκπαιδευτή για ανθρώπους του ιππικού χώρου και επιλέξτε την πλατφόρμα που θα συνεχίσει να εξελίσσεται μαζί σας και το 2026.",
      pills: [
        {
          icon: "Target",
          label: "Στόχοι & σχεδιασμός",
        },
        {
          icon: "Video",
          label: "Ανάλυση βίντεο",
        },
        {
          icon: "TrendingUp",
          label: "Πρόοδος",
        },
        {
          icon: "Users",
          label: "Πελάτες/συνδυασμοί",
        },
      ],
      ctas: [
        {
          label: "Ξεκινήστε δωρεάν ως εκπαιδευτής",
          href: "#start",
          primary: true,
        },
        {
          label: "Προς τον πίνακα σύγκρισης",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Γιατί το coaching μέσω WhatsApp εμποδίζει τους εκπαιδευτές.",
      lead: "Οι περισσότεροι εκπαιδευτές χρησιμοποιούν ξεχωριστά εργαλεία: WhatsApp για επικοινωνία, σημειωματάριο για μαθήματα, YouTube ή WeTransfer για βίντεο και Excel για αποτελέσματα αγώνων. Με 5 αναβάτες λειτουργεί. Με 20 αναβάτες χάνονται πληροφορίες, ξεχνάτε στόχους και χάνετε τον έλεγχο της ατομικής προόδου.",
      items: [
        "Πού είναι ο στόχος της Άννας για αυτή τη σεζόν;",
        "Ποιο βίντεο έστειλα στον Θανάση τον προηγούμενο μήνα;",
        "Είδε η Λαρα την ανάλυση πρωτοκόλλου του τελευταίου της αγώνα;",
        "Ποιος συνδυασμός προπονείται πόσες φορές την εβδομάδα;",
        "Διάβασε ο ιδιοκτήτης του Stardust τις οδηγίες προπόνησής μου;",
        "Πότε ήταν η τελευταία φορά που έδωσα ανατροφοδότηση για ασταθή ώθηση;",
      ],
    },
    what: {
      title: "Τι είναι μια εφαρμογή εκπαιδευτή για άλογο και αναβάτη;",
      lead: "Μια εφαρμογή εκπαιδευτή συνδυάζει ένα CRM coaching (συνδυασμοί, μαθήματα, στόχοι), ημερολόγιο προπόνησης ανά άλογο, ανατροφοδότηση μέσω βίντεο, σχεδιασμό αγώνων και ανάλυση πρωτοκόλλου. Όχι πλέον ξεχωριστά WhatsApp/YouTube/Excel, αλλά μία πλατφόρμα όπου εκπαιδευτής και αναβάτης συνεργάζονται.",
      targetGroupsTitle: "Για ποιον τύπο εκπαιδευτή προορίζεται;",
      targetGroups: [
        {
          icon: "Target",
          title: "Εκπαιδευτής δρεσάρ",
          body: "Σάρωση πρωτοκόλλου, σύνδεση σχολίων심κριτών με στόχους προπόνησης, παρακολούθηση προόδου.",
        },
        {
          icon: "Activity",
          title: "Εκπαιδευτής ιππασίας εμποδίων",
          body: "Σχεδιασμός παρκούρ, ανατροφοδότηση ανά γύρο, διαχείριση ύψους ανά άλογο.",
        },
        {
          icon: "Award",
          title: "Coach eventing",
          body: "Τρεις κλάδοι, τρεις σχεδιασμοί — όλοι ορατοί παράλληλα.",
        },
        {
          icon: "TrendingUp",
          title: "Coach επίδοσης (αθλητισμός)",
          body: "Παρακολούθηση EPI, αγώνες, στόχοι — για κορυφαίους αθλητές και τις ομάδες τους.",
        },
        {
          icon: "Users",
          title: "Εκπαιδευτής ιππικού κέντρου",
          body: "Ομαδικά μαθήματα + ατομικό coaching σε μία εφαρμογή.",
        },
        {
          icon: "Heart",
          title: "Εκπαιδευτής ψυχαγωγικής ιππασίας",
          body: "Ιππικοθεραπεία, αρχάριοι, ιδιοκτήτες με ένα άλογο.",
        },
      ],
    },
    criteria: {
      title: "Ποιες προδιαγραφές πρέπει να πληροί μια καλή εφαρμογή εκπαιδευτή;",
      lead: "Η εκπαίδευση είναι ανθρώπινη δουλειά, αλλά το σωστό εργαλείο σας κάνει 30-50% πιο αποδοτικούς και βοηθά τους αναβάτες να βελτιώνονται ακόμα και μεταξύ μαθημάτων.",
      items: [
        {
          icon: "Users",
          title: "Διαχείριση συνδυασμών",
          body: "Άλογο + αναβάτης ως μία ενότητα, με επίπεδο, στόχους, πρόοδο και ιστορικό.",
        },
        {
          icon: "ClipboardList",
          title: "Σημειώσεις μαθήματος & στόχοι",
          body: "Σημειώσεις ανά μάθημα με σημεία εστίασης, συνδεδεμένες με μακροπρόθεσμους στόχους.",
        },
        {
          icon: "Video",
          title: "Ανατροφοδότηση μέσω βίντεο",
          body: "Ανεβάστε βίντεο, επισημάνετε στιγμές, προσθέστε προφορική ή γραπτή ανατροφοδότηση.",
        },
        {
          icon: "Target",
          title: "Ανάλυση αγώνα & πρωτοκόλλου",
          body: "Σάρωση πρωτοκόλλων (KNHS/FEI), προβολή βαθμών ανά κλάδο, σχόλια κριτών και τάσεις.",
        },
        {
          icon: "Calendar",
          title: "Σχεδιασμός & κάρτες μαθημάτων",
          body: "Ημερολόγιο, πληρωμές, συνδρομές και αυτόματες υπενθυμίσεις.",
        },
        {
          icon: "Share2",
          title: "Επικοινωνία προς αναβάτη",
          body: "Ο αναβάτης βλέπει τη δική του σελίδα με μαθήματα, βίντεο, στόχους και ανατροφοδότηση.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs άλλες εφαρμογές εκπαιδευτή.",
      lead: "Ορισμένα εργαλεία εκπαιδευτή εστιάζουν στην αντικατάσταση του WhatsApp, άλλα στην ανάλυση πρωτοκόλλου. Το EquiSight συνδυάζει και τα δύο με ένα πραγματικό φάκελο αλόγου — ώστε ο αναβάτης να βελτιώνεται και μεταξύ των μαθημάτων.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Δωρεάν έναρξη",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Διαχείριση συνδυασμών",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Σημειώσεις μαθήματος & ανατροφοδότηση",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Μακροπρόθεσμοι στόχοι",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ανέβασμα βίντεο + ανατροφοδότηση",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Σάρωση πρωτοκόλλου KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Δείκτης Επίδοσης)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ημερολόγιο αγώνων",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Πύλη αναβάτη",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Κάρτα μαθημάτων / συνδρομή",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Online πληρωμές",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Ενσωματωμένος φάκελος αλόγου",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ορατότητα πεταλωτή/κτηνιάτρου",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Για εκπαιδευτή ΚΑΙ αναβάτη",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Πολλαπλά άλογα ανά αναβάτη",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Σύγκριση βάσει δημόσια διαθέσιμων λειτουργιών τον Ιανουάριο 2026. Το EquiSight είναι μοναδικό στην ανάλυση πρωτοκόλλου + EPI και συνδυάζει αυτό με γενική διαχείριση αλόγων.",
    },
    why: {
      title: "Γιατί το EquiSight προσφέρει διαφορετική εμπειρία εκπαιδευτή.",
      lead: "Τα περισσότερα εργαλεία εκπαιδευτή σταματούν όπου τελειώνει το μάθημα. Το EquiSight συνεχίζει — στον φάκελο αλόγου, στην ανάλυση αγώνων, στη συνεργασία με κτηνίατρο και ιδιοκτήτη.",
      points: [
        {
          icon: "TrendingUp",
          title: "Σάρωση πρωτοκόλλου → στόχος προπόνησης",
          body: "Σαρώστε ένα πρωτόκολλο KNHS και δείτε αμέσως ποιοι κλάδοι χρειάζονται προσοχή. Οι στόχοι προκύπτουν αυτόματα.",
        },
        {
          icon: "Sparkles",
          title: "Το EquiCoach ενισχύει την κρίση σας",
          body: "Δεδομένα από πολλαπλά μαθήματα, αγώνες και πρωτόκολλα αναδεικνύουν μοτίβα που δεν μπορείτε να κρατήσετε στο μυαλό σας.",
        },
        {
          icon: "Share2",
          title: "Ενσωματωμένο με το άλογο",
          body: "Ο εκπαιδευτής βλέπει το ιστορικό εμβολιασμών, πεταλώματος και τραυματισμών του αλόγου — χωρίς να σχεδιάζει προπόνηση κατά την ανάρρωση.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Για δρεσάρ και ιππασία εμποδίων",
      title: "Τι περιέχει ένας φάκελος coaching στο EquiSight.",
      lead: "Ανά συνδυασμό αποκτάτε μια ροή coaching που τα κρατά όλα μαζί — χωρίς να χάνετε πράγματα στο WhatsApp.",
      items: [
        "Σημειώσεις μαθήματος με σημεία εστίασης ανά συνεδρία",
        "Μακροπρόθεσμοι στόχοι + ορόσημα",
        "Ανέβασμα βίντεο με σχόλια σε χρονοκώδικα",
        "Σάρωση πρωτοκόλλου KNHS/FEI με βαθμούς",
        "Σχόλια κριτών συνδεδεμένα με προπόνηση",
        "Αποτελέσματα αγώνων και τάση EPI",
        "Επαφή πελατών και ιστορικό μαθημάτων",
        "Κάρτα μαθημάτων / συνδρομή / τιμολόγια",
        "Γράφημα προόδου ανά κλάδο",
        "Κοινή πρόσβαση με ιδιοκτήτη αλόγου",
      ],
      ctaLabel: "Δείτε το module εκπαιδευτή",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Από WhatsApp + YouTube στο EquiSight Trainer.",
      lead: "Συγκεκριμένα: έτσι αλλάζει η ροή εργασίας του coaching σας.",
      rows: [
        {
          before: "WhatsApp με ξεχωριστά links βίντεο",
          after: "Βίντεο με ανατροφοδότηση χρονοκώδικα στον φάκελο",
        },
        {
          before: "Σημειωματάριο ανά αναβάτη",
          after: "Ημερολόγιο coaching με στόχους + ιστορικό",
        },
        {
          before: "Excel με βαθμολογίες αγώνων",
          after: "Γράφημα EPI + ανάλυση πρωτοκόλλου",
        },
        {
          before: "Προφορικοί στόχοι",
          after: "Ορόσημα με δείκτη προόδου",
        },
        {
          before: "Ξεχωριστό εργαλείο τιμολόγησης",
          after: "Μαθήματα + iDEAL + συνδρομή στην εφαρμογή",
        },
        {
          before: "Email στον ιδιοκτήτη για την πρόοδο",
          after: "Ο ιδιοκτήτης παρακολουθεί από τη δική του προβολή",
        },
      ],
    },
    helper: {
      title: "Ποια εφαρμογή εκπαιδευτή σας ταιριάζει;",
      lead: "5 ερωτήσεις για να δείτε αν ένα εξειδικευμένο εργαλείο coaching προσφέρει προστιθέμενη αξία στη δραστηριότητά σας.",
      questions: [
        {
          id: "clients",
          q: "Πόσους ενεργούς συνδυασμούς εκπαιδεύετε;",
          options: [
            {
              label: "Λιγότερους από 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Περισσότερους από 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Ποιος είναι ο κύριος κλάδος σας;",
          options: [
            {
              label: "Δρεσάρ",
              score: 3,
            },
            {
              label: "Ιππασία εμποδίων",
              score: 2,
            },
            {
              label: "Ψυχαγωγικός / ποικίλος",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Χρησιμοποιείτε βίντεο στο coaching;",
          options: [
            {
              label: "Σπάνια",
              score: 0,
            },
            {
              label: "Μερικές φορές (χειροκίνητα)",
              score: 2,
            },
            {
              label: "Συχνά — συστηματικά",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Εκπαιδεύετε αναβάτες αγώνων;",
          options: [
            {
              label: "Όχι, ψυχαγωγικούς",
              score: 0,
            },
            {
              label: "Μερικές φορές σε αγώνες",
              score: 2,
            },
            {
              label: "Πολλούς — οι καρτέλες εκκίνησης είναι κεντρικές",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Θέλετε να μετράτε το coaching σας;",
          options: [
            {
              label: "Όχι, η διαίσθηση αρκεί",
              score: 0,
            },
            {
              label: "Θα ήθελα, αλλά δεν έχω χρόνο",
              score: 2,
            },
            {
              label: "Ναι — coaching βασισμένο σε δεδομένα",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Ένα απλό εργαλείο ή ακόμα και το WhatsApp αρκεί — προς το παρόν.",
          body: "Για λιγότερους από 5 αναβάτες χωρίς πολύ βίντεο ή αγώνες, μια εφαρμογή coaching είναι υπερβολή. Το EquiSight ξεκινά δωρεάν, οπότε μπορείτε να το δοκιμάσετε όταν η δραστηριότητά σας αναπτυχθεί.",
          cta: "Ξεκινήστε δωρεάν",
        },
        mid: {
          title: "Το EquiSight Trainer σας κάνει δομικά πιο αποδοτικούς.",
          body: "Με 5-15 συνδυασμούς χάνετε ώρες κάθε μήνα σε WhatsApp και ξεχωριστά βίντεο. Το EquiSight τα συγκεντρώνει όλα, σαρώνει αυτόματα τα πρωτόκολλα και διασφαλίζει ότι οι αναβάτες μπορούν πάντα να ανατρέχουν στην ανατροφοδότησή τους.",
          cta: "Δοκιμάστε το module Trainer",
        },
        high: {
          title: "Το EquiSight είναι κατασκευασμένο για την κλίμακα του coaching σας.",
          body: "Πολλοί αναβάτες, βίντεο, αγώνες και coaching βασισμένο σε δεδομένα: αυτό είναι ακριβώς όπου το EquiSight ξεχωρίζει. EPI + σάρωση πρωτοκόλλου + φάκελος αλόγου σας δίνει ένα πλεονέκτημα που οι ανταγωνιστές δεν έχουν.",
          cta: "Κλείστε μια demo για τη δραστηριότητα coaching σας",
        },
      },
    },
    faqTitle: "Συχνές ερωτήσεις για εφαρμογές εκπαιδευτή",
    faq: [
      {
        q: "Ποια είναι η καλύτερη εφαρμογή εκπαιδευτή για άλογο και αναβάτη;",
        a: "Για καθαρή επικοινωνία αρκούν πολλά εργαλεία (ακόμα και το WhatsApp). Για στόχους, ανάλυση βίντεο, σάρωση πρωτοκόλλου, παρακολούθηση αγώνων και διαχείριση πελατών σε ένα εργαλείο, το EquiSight είναι η πιο ολοκληρωμένη λύση — κυρίως επειδή παρακολουθεί και το ίδιο το άλογο, όχι μόνο τον συνδυασμό.",
      },
      {
        q: "Μπορεί το EquiSight να διαβάσει αυτόματα πρωτόκολλα αγώνων;",
        a: "Ναι. Ανεβάστε ένα πρωτόκολλο KNHS ή FEI και το EquiSight εξάγει τους βαθμούς ανά κλάδο, τα σχόλια κριτών και τα συνδέει με τον συνδυασμό. Οι τάσεις εμφανίζονται σε πολλούς αγώνες.",
      },
      {
        q: "Τι είναι το EPI (Equestrian Performance Index);",
        a: "Το EPI είναι μια βαθμολογία EquiSight που μετατρέπει πολλαπλά αποτελέσματα αγώνων σε έναν συγκρίσιμο δείκτη επίδοσης. Έτσι βλέπετε πραγματική πρόοδο μέσα από διαφορετικές κατηγορίες και κριτές.",
      },
      {
        q: "Μπορούν οι αναβάτες να κλείνουν και να πληρώνουν τα μαθήματά τους μόνοι τους;",
        a: "Ναι. Οι αναβάτες συνδέονται, βλέπουν διαθέσιμες ώρες μαθημάτων, αγοράζουν κάρτες μαθημάτων και πληρώνουν μέσω iDEAL. Εσείς εγκρίνετε τι θέλετε να προσφέρετε.",
      },
      {
        q: "Λειτουργεί και για εκπαιδευτή που εργάζεται σε ιππικό κέντρο;",
        a: "Ναι. Μπορείτε να εργαστείτε ως ελεύθερος επαγγελματίας εκπαιδευτής με δικούς σας πελάτες χωρίς να συνδέσετε έναν λογαριασμό ιππικού κέντρου. Οι πελάτες σας πληρώνουν απευθείας.",
      },
      {
        q: "Μπορώ να μεταφέρω υπάρχοντα βίντεο και σημειώσεις;",
        a: "Τα βίντεο μπορείτε να τα ανεβάσετε ανά συνδυασμό ή μέσω ενός εργαλείου μαζικής αποστολής. Εισαγωγή σημειώσεων μέσω CSV. Βοηθάμε ενεργούς εκπαιδευτές με εφάπαξ μεταφορά δεδομένων.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Οδηγοί & εργαλεία επιλογής για λογισμικό διαχείρισης αλόγων | EquiSight",
      description: "Όλοι οι οδηγοί EquiSight σε ένα μέρος: συγκρίσεις λογισμικού διαχείρισης αλόγων, εκτροφής, ιππικού κέντρου και εκπαιδευτή, συν εργαλεία επιλογής για το 2026.",
      keywords: [
        "οδηγοί λογισμικού αλόγων",
        "εργαλείο επιλογής διαχείρισης αλόγων",
        "σύγκριση λογισμικού εκτροφής",
        "οδηγός λογισμικού ιππικού κέντρου",
        "σύγκριση εφαρμογών εκπαιδευτή",
      ],
    },
    hub: {
      eyebrow: "Κόμβος · οδηγοί",
      breadcrumbLabel: "Οδηγοί",
      title: "Τέσσερις πλήρεις οδηγοί για να επιλέξετε το κατάλληλο λογισμικό αλόγων.",
      intro: "Ένα σε βάθος εργαλείο επιλογής για κάθε κοινό: πίνακες σύγκρισης, κριτήρια, παραδείγματα και διαδραστικό κουίζ. Κάντε κλικ στον οδηγό που ταιριάζει στην κατάστασή σας, ή εξερευνήστε πρώτα τα αναλυτικά άρθρα κάτω από κάθε ενότητα.",
      stats: {
        guides: "4 εργαλεία επιλογής",
        articles: "15 αναλυτικά άρθρα",
        fair: "Αμερόληπτη σύγκριση",
      },
      readMoreCta: "Διαβάστε τον πλήρη οδηγό",
      relatedHeading: "Αναλυτικά άρθρα",
      articlesCountSingular: "{{count}} αναλυτικό άρθρο",
      articlesCountPlural: "{{count}} αναλυτικά άρθρα",
      articlesCountAria: "Αριθμός άρθρων ενότητας",
      lastUpdatedPrefix: "Ενημερώθηκε",
      lastUpdatedAria: "Ημερομηνία τελευταίας ενημέρωσης αυτής της ενότητας",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Εργαλείο επιλογής εφαρμογής διαχείρισης αλόγων",
        blurb: "Συγκρίνετε τις πιο γνωστές εφαρμογές διαχείρισης αλόγων και ανακαλύψτε ποια ταιριάζει σε ιδιοκτήτη, στάβλο ή εκτροφείο. Περιλαμβάνει αμερόληπτο πίνακα σύγκρισης και εργαλείο επιλογής 5 ερωτήσεων.",
        audience: "Για ιδιοκτήτες, ιδιοκτήτες στάβλων και όλους τους φιλόιππους που αναζητούν οργάνωση.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Σύγκριση λογισμικού εκτροφής αλόγων",
        blurb: "Από τον κύκλο της φοράδας έως την ανάπτυξη του πουλαριού: δείτε ποιο λογισμικό εκτροφής λειτουργεί πραγματικά για τον αριθμό των φοράδων σας, τη μέθοδο εκτροφής και τις απαιτήσεις του στάβλου.",
        audience: "Για (ερασιτέχνες) εκτροφείς, εκτροφεία και ιδιοκτήτες επιβητόρων.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Εργαλείο επιλογής λογισμικού ιππικού κέντρου",
        blurb: "Προγραμματισμός μαθημάτων, διαχείριση αναβατών, πύλη ιδιοκτητών και τιμολόγηση — σε ένα εργαλείο. Συγκρίνετε τις επιλογές για ιππικά κέντρα και στάβλους διαμονής αλόγων το 2026.",
        audience: "Για ιππικά κέντρα, στάβλους διαμονής αλόγων και επιχειρήσεις ιππασίας.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Εργαλείο επιλογής εφαρμογής εκπαιδευτή",
        blurb: "CRM προπόνησης, βιντεοσχόλια, σάρωση πρωτοκόλλου KNHS και στόχοι ανά συνδυασμό. Ποια εφαρμογή εκπαιδευτή ταιριάζει στην προπονητική σας πρακτική;",
        audience: "Για εκπαιδευτές, προπονητές και coaches.",
      },
    ],
    closing: {
      eyebrow: "Γιατί αυτοί οι οδηγοί",
      title: "Αμερόληπτη σύγκριση, όχι μόνο τιμές.",
      body1: "Πολλές «σελίδες σύγκρισης» είναι στην πράξη διαφημίσεις. Οι οδηγοί μας παραθέτουν λειτουργίες, κοινό-στόχο και ανταγωνιστές δίπλα-δίπλα, όπως θα έκανε μια ανεξάρτητη πηγή γνώσης. Το EquiSight αναδεικνύεται φυσικά ως πλήρης λύση, αλλά θα διαβάσετε επίσης με ειλικρίνεια πού άλλες εφαρμογές υπερτερούν.",
      body2: "Τα αναλυτικά άρθρα κάτω από κάθε οδηγό απαντούν στα συγκεκριμένα ερωτήματα που προκύπτουν από την επιλογή: «Πότε η πρώτη υπερηχογραφία μετά την τεχνητή γονιμοποίηση», «Πώς αυτοματοποιώ την τιμολόγηση ιππικού κέντρου», «Πώς αναλύω ένα πρωτόκολλο αγώνα». Χωρίς μάρκετινγκ χωρίς ουσία, μόνο πρακτική γνώση.",
    },
    hubName: "EquiSight Οδηγοί",
  },
  ui: {
    sectionEyebrows: {
      pains: "Γιατί αυτό είναι πρόβλημα",
      basics: "Βασικά",
      criteria: "Τι το κάνει καλό;",
      comparison: "Έντιμη σύγκριση",
      why: "Η διαφορά",
      beforeAfter: "Από τον κατακερματισμό στην επισκόπηση",
      helper: "5 ερωτήσεις",
    },
    table: {
      feature: "Λειτουργία",
      today: "Σήμερα",
      withEquisight: "Με το EquiSight",
    },
    helper: {
      questionLabel: "Ερώτηση {{current}} από {{total}}",
      answerPrompt: "Απαντήστε την {{count}} εναπομένουσα ερώτηση για να δείτε μια σύσταση.",
      answerPromptPlural: "Απαντήστε τις {{count}} εναπομένουσες ερωτήσεις για να δείτε μια σύσταση.",
      resultEyebrow: "Το αποτέλεσμά σας",
    },
    targetGroupsFallback: "Για ποιον προορίζεται αυτό;",
    faqTitleFallback: "Συχνές ερωτήσεις",
  },
};

export default CORNERSTONES;
